// This file is being replaced by the same file in trellis-theming-assets as part of the Trellis modern theme rollout.
// This file will be deleted soon, in the unlikely event any changes are made here, be sure to also make them in trellis-theming-assets.
import { setupTheme } from '../setup-theme';
import multiTheme from './multi-theme';
window.__hubspotTheme = multiTheme;
setupTheme();